import './styles/main.scss';

//
//   Global App Variable
//
//////////////////////////////////////////////////////////////////////

window.APP = window.APP || {};

import Router from './scripts/router.js';

import GlobalRoute from './scripts/routes/global.js';

import StyleGuideRoute from './scripts/routes/styleguide';
import ProductRoute from './scripts/routes/product';
import HomeRoute from './scripts/routes/home';
import BlogRoute from './scripts/routes/blog';
import PartnersRoute from './scripts/routes/partners';
import FindAPartnerRoute from './scripts/routes/findAPartner';
import AboutRoute from './scripts/routes/about';
import InTheFieldRoute from './scripts/routes/inTheField';
import CommerceRoute from './scripts/routes/commerce';
import ContactRoute from './scripts/routes/contact';
import GlossaryRoute from './scripts/routes/glossary';
import TermRoute from './scripts/routes/term';
import EnterpriseRoute from './scripts/routes/enterprise';
import SupportServicesRoute from './scripts/routes/supportServices';
import PageContentRoute from './scripts/routes/pageContent';
import DemoRoute from './scripts/routes/demo';
import EventsRoute from './scripts/routes/events';
import PricingRoute from './scripts/routes/pricing';
import LandingRoute from './scripts/routes/landing.js';
import ProjectsGalleryLiteRoute from './scripts/routes/projectsGalleryLite.js';

//
//   App Routes
//
//////////////////////////////////////////////////////////////////////

const router = new Router({
  '^/styleguide': StyleGuideRoute,
  '^/product/?$': ProductRoute,
  '^/?$': [HomeRoute, ProjectsGalleryLiteRoute],
  '^/.+/?$': [LandingRoute, ProjectsGalleryLiteRoute],
  '^/blog': BlogRoute,
  '^/partners': PartnersRoute,
  '^/partners-new': PartnersRoute,
  '^/partners/find-a-partner': FindAPartnerRoute,
  '^/about': AboutRoute,
  '^/in-the-field': InTheFieldRoute,
  '^/commerce': CommerceRoute,
  '^/why-craft-for-developers': CommerceRoute,
  '^/contact': ContactRoute,
  '^/glossary/?$': GlossaryRoute,
  '^/glossary/.+/?$': TermRoute,
  '^/enterprise': EnterpriseRoute,
  '^/support-services': SupportServicesRoute,
  '^/demo': DemoRoute,
  '^/events': EventsRoute,
  '^/pricing': PricingRoute,
  '^/commerce/pricing': PricingRoute,
  '^/cloud': PricingRoute,
  '^/ecommerce': PricingRoute,

  // This has historically run last (but on all paths):
  '.*': [GlobalRoute, PageContentRoute],
});

//
//   App Initiation
//
//////////////////////////////////////////////////////////////////////
APP.mediaQueries = {
  small: 'screen and (min-width: 500px)',
  medium: 'screen and (min-width: 768px)',
  large: 'screen and (min-width: 1024px)',
  xlarge: 'screen and (min-width: 1368px)',
  xxlarge: 'screen and (min-width: 1596px)',
  hamburger: 'screen and (max-width: 768px)'
};

APP.init = function() {
  router.handle(window.location.pathname);
};

//
//   Kickoff
//
//////////////////////////////////////////////////////////////////////

APP.init();
